
import { mapState } from "vuex";
import orderRejectReasonDialog from "../dialogs/order-reject-reason-dialog.vue";
import OrderReprintKotDialog from "../dialogs/order-reprint-kot-dialog.vue";
export default {
  components: { orderRejectReasonDialog, OrderReprintKotDialog },
  data() {
    return {
      rejectOrderReasonDialog: false,
      reprintKotDialog: false,
      status: ""
    };
  },
  props: {
    isModificationEnabled: {
      type: Boolean,
      default: false
    },
    isEnabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState("reciever", ["orderDetails"]),
    isInactiveState() {
      return (
        this.orderDetails.status ==
          this.$constants.OrderStatuses.COMPLETED.id ||
        this.orderDetails.status == this.$constants.OrderStatuses.CANCELLED.id
      );
    },
    isNotCancellable() {
      return (
        this.isInactiveState ||
        (this.orderDetails.status !==
          this.$constants.OrderStatuses.NEW_ORDER.id &&
          (this.orderDetails.source !== this.$constants.Channels.ZOMATO.name ||
            this.orderDetails.source !== this.$constants.Channels.SWIGGY.name))
      );
    }
  },
  methods: {
    modifyItemAction() {
      if (!this.isModificationEnabled) {
        this.$nuxt.$emit("show-info-dialog", {
          content: "You're not allowed to modify this order."
        });
      } else {
        this.$emit("show-availability-toggle");
      }
    },
    rePrintKot() {
      this.reprintKotDialog = true;
      this.status = "reprint";
    }
  }
};
